<template>
  <div v-if="input">
    <Dialog
      :header="$t('edit-games')"
      :visible="active"
      :style="{ maxWidth: '90%', width: 'auto', minWidth: '300' }"
      :modal="true"
      :closable="false"
    >
      <div>
        <div class="p-my-3">
          <h3 class="title is-4">{{ $t("choose-games") }}</h3>
        </div>
        <div class="p-my-4">
          <Button
            @click="selectAll"
            :label="$t('select-all')"
            icon="pi pi-check"
            class="p-button-sm p-button-outlined"
          />
          &nbsp;
          <Button
            @click="clearAll"
            :label="$t('select-none')"
            icon="pi pi-times"
            class="p-button-sm p-button-outlined"
          />
        </div>
        <div v-for="event in input" :key="event.value" class="p-field-checkbox">
          <Checkbox :id="event.id" :value="event.id" v-model="selectedGames" />
          <label :for="event.id">{{ event.label }} </label>
        </div>
      </div>
      <div v-if="selectedGames.length" class="p-mt-3" style="min-height: 300px">
        <div class="title is-5 p-mb-5">{{ $t("what-would-you-like-to-do") }}</div>
        <div class="p-mt-4">
          <div v-for="option in editOptions" :key="option.value" class="p-field-radiobutton">
            <RadioButton :value="option" v-model="editSelection" />
            <label for="o1">{{ option.name }} </label>
          </div>
          <!-- <Dropdown
            :options="editOptions"
            optionLabel="name"
            placeholder="Select Action"
            style="width: 100%"
            class="p-mt-3"
            v-model="editSelection"
          /> -->
        </div>

        <div v-if="editSelection" style="max-width: 500px; margin: 0 auto">
          <div v-if="editSelection.value == 'shift'" class="p-mt-5">
            <div class="title is-4">{{ $t("move-by") }}</div>
            <div class="p-grid">
              <div class="p-col-6">
                <Dropdown
                  :options="moveOptions.numbers"
                  :placeholder="$t('choose-amount')"
                  style="width: 100%"
                  class="p-mt-3"
                  v-model="moveChoices.amount"
                />
              </div>
              <div class="p-col-6">
                <Dropdown
                  :options="moveOptions.units"
                  :placeholder="$t('choose-unit')"
                  style="width: 100%"
                  class="p-mt-3"
                  v-model="moveChoices.units"
                />
              </div>
            </div>
          </div>
          <p class="p-my-3" v-if="editSelection.value == 'delete'">
            {{
              $t(
                "this-will-delete-the-game-permanently-if-you-just-want-to-reschedule-this-game-use-send-to-unscheduled-list",
              )
            }}
          </p>
          <p class="p-my-3" v-else-if="editSelection.value == 'reschedule'">
            {{
              $t(
                "this-will-remove-timeslots-for-these-games-the-game-will-be-preserved-and-they-will-be-available-for-rescheduling",
              )
            }}
          </p>
          <div class="p-my-3" v-else-if="editSelection.value == 'umpire'">
            {{ $t("choose-umpire") }}
          </div>
          <p class="p-my-3" v-else-if="editSelection.value == 'swap'">
            {{ $t("these-two-games-will-swap-their-timeslots-and-venues") }}
          </p>
          <p class="p-my-3" v-else-if="editSelection.value == 'shift'">
            {{ $t("these-games-will-be-shifted-by") }}
            <strong> {{ moveChoices.amount }} {{ moveChoices.units }}</strong
            >.
          </p>
          <v-popover>
            <Button :label="$t('Button.continue')" :disabled="!selectedGames.length"></Button>
            <!-- This will be the content of the popover -->
            <template slot="popover">
              <div class="popover-wrapper">
                <div class="popover-title">{{ $t("confirm-editselection-abbr", [editSelection.abbr]) }}</div>
                <div class="popover-content"><br />{{ $t("are-you-sure-this-cannot-be-undone") }}</div>
                <div class="popover-actions mt-2">
                  <button class="button is-small" @click="confirmEditAction">
                    {{ $t("Button.confirm") }}
                  </button>
                  <br />
                  <br />
                  <button v-close-popover class="button is-small is-white">
                    {{ $t("Button.cancel") }}
                  </button>
                </div>
              </div>
            </template>
          </v-popover>
        </div>
        <div class="p-my-3">
          <Button :label="$t('Button.cancel')" @click="emitHide" class="p-button-text"></Button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import api from "@/api";

export default {
  props: {
    input: {
      type: Array,
      required: false,
    },
    active: {
      type: Boolean,
      required: true,
    },
    schedule: {
      type: Object,
      required: false,
    },
  },
  // dddd
  data() {
    return {
      selectedGames: [],
      editSelection: null,
      moveOptions: {
        numbers: [],
        units: [this.$t("minutes"), this.$t("hours"), this.$t("days"), this.$t("weeks"), this.$t("months")],
      },
      moveChoices: {
        units: this.$t("days"),
        amount: 1,
      },
      date: null,
      timeslot: {
        start: null,
        finish: null,
        venue_id: null,
        surface_id: null,
      },
      game: {
        home_id: null,
        visitor_id: null,
        schedule_id: null,
      },
      schedule_item_id: null,
    };
  },
  computed: {
    editOptions() {
      var x = [];
      if (this.selectedGames.length == 2) {
        x.push({
          name: this.$t("swap-timeslots-2-games"),
          abbr: this.$t("swap-games"),
          value: "swap",
        });
      }
      x.push({
        name: this.$t("send-to-unscheduled-list"),
        abbr: this.$t("rescheduling"),
        value: "reschedule",
      });

      x.push({ name: this.$t("shift-times"), abbr: this.$t("shift-times"), value: "shift" });
      x.push({ name: this.$t("delete-entirely"), abbr: this.$t("deletion"), value: "delete" });
      return x;
    },
    title() {
      var str = "";
      if (this.input) {
        str += this.$t("edit-game");
      } else {
        str += this.$t("create-game");
      }
      if (this.schedule && this.schedule.name) {
        str += " in " + this.schedule.name;
      }
      return str;
    },
    seasonItems() {
      if (!this.$store.getters.currentSeason) {
        return {};
      }
      var venues = [];
      var teams = [];
      var surfaces = [];
      var division_id = null;
      if (this.schedule) {
        division_id = this.schedule.division_id;
      }
      this.$store.getters.currentSeason.venues.forEach(v => {
        venues.push({
          name: v.name,
          id: v.id,
          surfaces: v.surfaces,
        });
        if (this.timeslot.venue_id == v.id) {
          v.surfaces.forEach(s => {
            surfaces.push(s);
          });
        }
      });

      this.$store.getters.currentSeason.teams.forEach(t => {
        if (!division_id || t.division_id == division_id) {
          teams.push({
            name: t.name,
            id: t.id,
          });
        }
      });

      var x = {
        venues: venues,
        teams: teams,
        surfaces: surfaces,
        schedules: this.$store.getters.currentSeason.schedules,
      };
      return x;
    },
    valid() {
      return (
        !!this.timeslot.start &&
        !!this.timeslot.finish &&
        !!this.timeslot.venue_id &&
        !!this.timeslot.surface_id &&
        !!this.game.home_id &&
        !!this.game.visitor_id
      );
    },
  },
  methods: {
    selectAll() {
      this.selectedGames = [];
      this.input.forEach(e => {
        this.selectedGames.push(e.id);
      });
    },
    clearAll() {
      this.selectedGames = [];
    },
    confirmEditAction() {
      var ids = [];
      this.selectedGames.forEach(i => {
        ids.push(i);
      });
      if (this.editSelection.value == "swap") {
        api
          .swapScheduleItems({
            items: ids,
          })
          .then(response => {
            console.log(response);
            this.makeToast("success", this.$t("swapped-games"));
            this.refresh();
          })
          .catch(e => {
            this.makeToast("error", this.$t("Toast.could-not-complete-action"));
            console.log(e);
          });
      } else if (this.editSelection.value == "reschedule") {
        api
          .unscheduleItems({
            items: ids,
          })
          .then(response => {
            console.log(response);
            this.makeToast("success", this.$t("unscheduled-games"));
            this.refresh();
          })
          .catch(e => {
            console.log(e);
            this.makeToast("error", this.$t("Toast.could-not-complete-action"));
          });
      } else if (this.editSelection.value == "shift") {
        api
          .moveScheduleItems({
            items: ids,
            units: this.moveChoices.units,
            amount: this.moveChoices.amount,
          })
          .then(response => {
            this.makeToast("success", this.$t("shifted-games"));
            this.refresh();
          })
          .catch(e => {
            console.log(e);
            this.makeToast("error", this.$t("Toast.could-not-complete-action"));
          });
      } else if (this.editSelection.value == "delete") {
        api
          .deleteScheduleItems({
            items: ids,
          })
          .then(response => {
            this.makeToast("success", this.$t("deleted-games"));
            this.refresh();
          })
          .catch(e => {
            console.log(e);
            this.makeToast("error", this.$t("Toast.could-not-complete-action"));
          });
      }
    },
    save() {
      var item = {
        id: this.input ? this.input.id : null,
        timeslot: this.timeslot,
        game: this.game,
      };
      console.log("Save", item);
      if (this.input) {
        this.updateGame(item);
      } else {
        this.createGame(item);
      }
    },
    createGame(item) {
      console.log("CreateGame");
      api
        .createScheduleItem(this.$store.getters.currentSeason.id, item)
        .then(response => {
          console.log(response);
          this.makeToast("success", this.$t("created-game"));
          this.refresh();
        })
        .catch(e => {
          console.log(e);
          this.makeToast("error", e.response.data["errors"]);
        });
    },
    updateGame(item) {
      console.log("UpdateGame");
      api
        .updateScheduleItem(this.$store.getters.currentSeason.id, item)
        .then(response => {
          console.log(response);
          this.makeToast("success", this.$t("Toast.update_item"));
          this.refresh();
        })
        .catch(e => {
          console.log(e);
        });
    },
    emitHide() {
      this.$emit("hide");
    },
    refresh() {
      this.$emit("refresh");
    },
  },
  mounted() {
    this.moveOptions.numbers = [];
    var i = 1;
    while (i < 21) {
      this.moveOptions.numbers.push(i);
      this.moveOptions.numbers.push(-1 * i);
      i++;
    }
  },
  watch: {
    active: function(val) {
      if (val) {
        this.selectAll();
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
